import { PayloadAuthenticated } from "@tt-app/models";
import { VUEX_ROOT_GETTER_NAMES } from "@tt-app/constants";

/**
 * Helper to wait for authentication info to be available. Timeout is not
 * implemented so the wait is potentially infinite
 *
 * @param rootGetters Vuex root getters
 * @param retryPeriod duration, in milliseconds, to wait before a retry
 */
export const getAuthInfo = async (
  rootGetters: any,
  retryPeriod = 500
): Promise<PayloadAuthenticated> => {
  let authInfo = rootGetters[VUEX_ROOT_GETTER_NAMES.AUTH_INFO];

  //   let i = 1;
  while (authInfo === undefined) {
    // console.debug(`getAuthInfo: Wait #${i}`);
    await new Promise(r => setTimeout(r, retryPeriod));
    authInfo = rootGetters[VUEX_ROOT_GETTER_NAMES.AUTH_INFO];
    // i++;
  }

  return authInfo;
};
